import { ReactNode } from 'react';
import getAmoutValue from 'ui/structure/AmountValue/AmountValue';
import getCurrencyValue from 'ui/structure/CurrencyValue/CurrencyValue';
import InvoiceDescriptionValue from 'ui/structure/InvoiceDescriptionValue/InvoiceDescriptionValue';
import { ITransactionField } from 'ui/structure/TransactionCard';
import { objectMap } from 'utils/helpers';
import { ghsFormatter } from '../formatters';

// Can be expanded or splitted to modules
export const transactionDataConfig = {
  account: 'Account:',
  accountNumber: 'Account:',
  sourceAccount: 'Source Account:',
  sourceAccountName: 'Payer Name:',
  destinationAccountNo: 'Destination Account:',
  beneficiaryAccount: 'Beneficiary Account:',
  amount: 'Amount:',
  totalAmount: 'Total Amount:',
  transactionCharge: 'Transaction Charge:',
  destinationBankName: 'Destination Bank:',
  destinationAccountName: 'Beneficiary Name:',
  narration: 'Narration:',
  transferType: 'Transfer Type:',
  bank: 'Bank:',
  linkedWallet: 'Linked Wallet:',
  network: 'Network:',
  networkCode: 'Network:',
  networkName: 'Network:',
  dataBundle: 'Data Bundle:',
  productCode: 'Data Bundle:',
  billerCode: 'Biller:',
  eLevyFee: 'ELevy Fee:',
  eLevyCharge: 'ELevy Fee:',
  billNumber: 'Card/Bill Number:',
  cardType: 'Card Type:',
  cardNumber: 'Card:',
  customerId: 'Customer ID:',
  beneficiaryName: 'Beneficiary Name:',
  chequeNumber: 'Cheque Number:',
  customerName: 'Customer Name:',
  serviceType: 'Service Type:',
  serviceName: 'Service Name:',
  stopRequestType: 'Stop Cheque Request Type:',
  reasonToStop: 'Reason To Stop Cheque Request:',
  charge: 'Charge:',
  amountOnCheque: 'Amount on Cheque:',
  frequency: 'Frequency:',
  startDate: 'Special Date:',
  phoneNumber: 'Phone Number:',
  last4Digit: 'Card’s Last 4 Digits:',
  cardName: 'Card Name:',
  invoiceNumber: 'Invoice Number:',
  transactionFee: 'Transaction Fee:',
  transactionAmount: 'Transaction Amount:',
  principalAmount: 'Principal Amount:',
  scheduleId: 'Schedule ID:',
  transactionId: 'Transaction ID:',
  transactionDate: 'Transaction Date:',
  createDate: 'Transaction Date:',
  beneficiaryBank: 'Beneficiary Bank:',
  transactionType: 'Transaction Type:',
};

export const transactionValuesMapper = (value: string | number, key: string) => {
  switch (key) {
    case 'amount':
    case 'totalAmount':
    case 'PrincipalAmount':
    case 'eLevyFee':
    case 'eLevyCharge':
    case 'principalAmount':
      return getAmoutValue(String(value));
    case 'transactionFee':
      return getAmoutValue(String(value));
    case 'amountOnCheque':
      return getCurrencyValue(String(value));
    case 'charge':
      return getAmoutValue(String(value));
    case 'payAmount':
      return getAmoutValue(String(value));
    case 'contributionAmount':
      return getAmoutValue(String(value));
    case 'penaltyAmount':
      return getCurrencyValue(String(value));
    case 'transactionAmount':
      return getAmoutValue(String(value));
    case 'invoiceDescription':
      return InvoiceDescriptionValue(String(value));
    case 'transactionCharge':
      return ghsFormatter.format(Number(value));
    case 'totalTransactionAmount':
      return ghsFormatter.format(Number(value));
    default:
      return value;
  }
};

export const getTransactionsArray = (
  data: Record<string, string | number>,
  config: Record<string, string> = transactionDataConfig,
  mapper: (value: string | number, key: string) => ReactNode = transactionValuesMapper,
  sortArray?: string[],
  currency = 'GHS',
): ITransactionField[] => {
  const mappedData = objectMap<ReactNode, string | number>(data, mapper, config);
  const transactionsArray: ITransactionField[] = [];
  const loopWithKeys = sortArray || Object.keys(mappedData);

  loopWithKeys.forEach((key) => {
    const value = mappedData[key];
    if (typeof value === 'undefined') return;
    if (key === 'Amount:') {
      transactionsArray.push({
        label: key,
        value: getAmoutValue(
          data[
            key
              .toLocaleLowerCase()
              .replaceAll('', '')
              .slice(0, key.length - 1)
          ],
          currency,
        ),
      });
    } else {
      transactionsArray.push({ label: key, value });
    }
  });

  return transactionsArray;
};
